const KEY = 'tts.prefs.v1';
let listeners = new Set();

function load(){
  try { const data = JSON.parse(localStorage.getItem(KEY)||'{}'); return data && typeof data==='object' ? data : {}; } catch { return {}; }
}
function save(p){ localStorage.setItem(KEY, JSON.stringify(p)); listeners.forEach(l=> l(p)); }
export function getPrefs(){ return load(); }
export function updatePrefs(part){ const next = { ...load(), ...part }; save(next); }
export function subscribe(fn){ listeners.add(fn); fn(load()); return ()=> listeners.delete(fn); }
